<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{action}}</div>
    <div slot="body">
      <!--a-alert :message="$t('system.text_508', [$t('dictionary.role')])" type="warning" class="mb-2" /-->
      <dialog-selected-tips :name="$t('dictionary.user')" :count="params.data.length" :action="action" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item :label="$t('dictionary.domain')" v-if="isAdminMode">
          <a-radio-group v-decorator="decorators.domain" @change="domainChange" v-if="!l3PermissionEnable">
            <a-radio-button v-for="item in domainOptions" :value="item.key" :key="item.key">{{ item.label }}</a-radio-button>
          </a-radio-group>
          <base-select v-else
            v-decorator="decorators.domain"
            version="v1"
            resource="domains"
            filterable
            :params="domainParams"
            :select-props="{ placeholder: $t('rules.project') }"
            @change="domainChange" />
        </a-form-item>
        <a-form-item :label="$t('dictionary.project')">
          <base-select
            resource="projects"
            v-decorator="decorators.projects"
            filterable
            remote
            :select-props="{placeholder: $t('rules.project'), mode: 'multiple'}"
            :params="projectParams">
            <template #optionLabelTemplate="{item}">
              {{item.name}}
            </template>
          </base-select>
        </a-form-item>
        <a-form-item :label="$t('dictionary.role')">
          <base-select
            resource="roles"
            v-decorator="decorators.roles"
            filterable
            remote
            :select-props="{placeholder: $t('rules.role'), mode: 'multiple'}"
            :params="roleParams">
            <template #optionLabelTemplate="{item}">
              {{item.name}}
            </template>
          </base-select>
        </a-form-item>
        <a-form-item v-if="isUserDisabled" :label="$t('iam.enabled_user')" v-bind="formItemLayout" :extra="$t('iam.user_can_enabled')">
          <a-switch
            :checkedChildren="$t('common_292')"
            :unCheckedChildren="$t('common_293')"
            v-decorator="decorators.enabled" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ submitButtonText }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
// import get from 'lodash/get'
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import workflowMixin from '@/mixins/workflow'
import { WORKFLOW_TYPES } from '@/constants/workflow'
import { uuid } from '@/utils/utils'

export default {
  name: 'UserProjectJoinDialog',
  mixins: [DialogMixin, WindowsMixin, workflowMixin],
  data () {
    const domainId = this.params.data[0].domain_id
    return {
      action: this.$t('system.text_195', [this.$t('dictionary.project')]),
      loading: false,
      projectList: [],
      projectLoading: false,
      roleList: [],
      roleLoading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      domainId,
      decorators: {
        domain: [
          'domain',
          {
            initialValue: domainId,
          },
        ],
        projects: [
          'projects',
          {
            rules: [
              { required: true, message: this.$t('rules.project') },
            ],
          },
        ],
        roles: [
          'roles',
          {
            rules: [
              { required: true, message: this.$t('rules.role') },
            ],
          },
        ],
        enabled: [
          'enabled',
          {
            initialValue: false,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isDomainMode', 'isAdminMode', 'l3PermissionEnable', 'scope', 'userInfo']),
    isExecuteResourceOrderSetEnabled () {
      return this.checkWorkflowEnabled(WORKFLOW_TYPES.EXECUTE_USER_JOIN)
    },
    submitButtonText () {
      return this.isExecuteResourceOrderSetEnabled ? this.$t('system.text_532') : this.$t('dialog.ok')
    },
    domainOptions () {
      return [{
        label: 'Default',
        key: 'default',
      }]
    },
    domainParams () {
      return {
        scope: this.scope,
      }
    },
    projectParams () {
      const ret = {
        scope: this.scope,
        project_domain_id: this.domainId,
        limit: 20,
      }
      return ret
    },
    roleParams () {
      const ret = {
        scope: this.scope,
        project_domain_id: this.domainId,
        limit: 20,
      }
      return ret
    },
    isUserDisabled () {
      return !this.params.data[0].enabled
    },
  },
  created () {
    if (!this.l3PermissionEnable) {
      this.domainId = 'default'
    }
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        // 如果启用了 execute-user-join 工单类型，则创建工单
        if (this.isExecuteResourceOrderSetEnabled) {
          await this.joinProjectByWorkflow(values)
        } else {
          // 否则直接加入项目
          const manager = new this.$Manager('users', 'v1')
          await manager.performAction({
            id: this.params.data[0].id,
            action: 'join',
            data: values,
          })
          this.cancelDialog()
          this.$bus.$emit('UserSidepageProjectsListRefresh')
          if (values.enabled) {
            this.$bus.$emit('RefreshUser', this.params.data[0].id)
          }
        }
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    async joinProjectByWorkflow (values) {
      try {
        const userId = this.params.data[0].id
        // 获取项目信息
        // projects 可能是字符串ID或数组，取第一个
        const projectId = Array.isArray(values.projects) ? values.projects[0] : values.projects
        const domainId = values.domain || this.domainId || 'default'
        const projectData = await this.$store.dispatch('storage/getProjectById', {
          key: projectId,
          project_domain: domainId,
        })

        // 创建 resource_order_sets
        const orderSetManager = new this.$Manager('resource_order_sets')
        const { displayname, name } = this.userInfo
        const projectDomainName = projectData?.project_domain || (domainId === 'default' ? 'Default' : domainId)
        const orderSetData = {
          auto_execute: false,
          name: this.$t('iam.user_join_project_workflow_name', [displayname || name, this.$moment().format('YYYY-MM-DD'), uuid()]),
          parameters: [{
            action: 'perform',
            perform_action_name: 'join',
            resource: 'users',
            resource_id: userId,
            project: projectId,
            project_domain: projectDomainName,
            parameter: {
              projects: values.projects,
              roles: values.roles,
            },
          }],
        }
        const orderSetRes = await orderSetManager.create({ data: orderSetData })

        // 创建工单
        const variables = {
          process_definition_key: WORKFLOW_TYPES.EXECUTE_USER_JOIN,
          initiator: this.userInfo.id,
          ids: orderSetRes.data.id,
          parameter: '{}',
          project: projectId,
          project_domain: projectData?.project_domain_id || domainId,
          execute_resource_order_set_type: 'users_perform_join',
        }
        await this.createWorkflow(variables)
        this.$message.success(this.$t('common.worflow_tip', [this.$t('system.text_195', [this.$t('dictionary.project')])]))
        this.cancelDialog()
        this.$router.push('/workflow')
      } catch (error) {
        throw error
      }
    },
    domainChange (val) {
      this.domainId = val
    },
  },
}
</script>
